<template>
  <div class="app-container">
    <el-container>
      <el-aside width="400px" class="cbox-p14">
        <div class="section-header">数据字典</div>
        <div class="search-box">
          <el-input v-model.trim="filterText" placeholder="输入关键词进行筛选" prefix-icon="el-icon-search" clearable></el-input>
        </div>
        <div class="button-box">
          <el-button type="primary" @click="handleAddOrigin">新增根字典</el-button>
          <el-button type="primary" @click="handleAddChildren" plain>新增下级字典</el-button>
          <el-button type="danger" @click="handleDelete">删除</el-button>
        </div>
        <div class="tree-box">
          <el-tree
            ref="tree"
            :data="treeData"
            :current-node-key="currentNodeId"
            node-key="id"
            highlight-current
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            @node-click="handleTreeNode"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </el-aside>

      <el-main class="cbox-p14">
        <div class="section-header">字典信息</div>

        <el-form
          v-show="this.editForm.levelCode"
          ref="editForm"
          class="dashed-border"
          v-loading="infoLoading"
          :model="editForm"
          :rules="rules"
          label-width="120px"
        >
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="24">
              <el-form-item label="上级字典" prop="parentName">
                <el-input disabled v-model="editForm.parentName" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="字典名称" prop="name">
                <el-input v-model.trim="editForm.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字典编码" prop="code">
                <el-input v-model.trim="editForm.code" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="层级编码" prop="levelCode">
                <el-input disabled v-model="editForm.levelCode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="值" prop="value">
                <el-input v-model.trim="editForm.value" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="附加值1" prop="valuex">
                <el-input v-model.trim="editForm.valuex" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="附加值2" prop="valuey">
                <el-input v-model.trim="editForm.valuey" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址" prop="address">
                <el-input v-model.trim="editForm.address" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否可用" prop="deleted">
                <el-switch
                  v-model="editForm.deleted"
                  :active-value="0"
                  :inactive-value="1"
                  active-text="启用"
                  inactive-text="禁用"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="图片">
                <ImageUpload v-model="fileList" :paramsData="fileParams" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="富文本" prop="remark">
                <Kind-editor
                  id="kindeditor"
                  ref="kindeditor"
                  height="200px"
                  :content="editForm.remark"
                  @input="e => getContent(e, 'remark')"
                ></Kind-editor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="this.editForm.levelCode" class="form-buttons">
          <el-button :loading="saveLoading" type="primary" @click="handleSave">保存</el-button>
        </div>

        <el-empty v-if="!this.editForm.levelCode" description="请选择字典信息"></el-empty>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ImageUpload from '@/components/UploadArea/ImageUpload';
import KindEditor from '@/components/Kindeditor';

import { getDictData, getDict, saveDict, deleteDict } from '@/api/system';

import { getNextCode } from '@/utils/index';

export default {
  components: { ImageUpload, KindEditor },
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'nodes',
        label: 'text'
      },
      treeData: [],
      infoLoading: false,
      currentTreeNode: null,
      currentNodeId: null,
      editForm: {
        deleted: 0,
        remark: '',
        name: ''
      },
      fileParams: {
        type: 'upt_img'
      },
      fileList: [],
      rules: {
        name: [{ required: true, message: '请输入字典名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入字典编码', trigger: 'blur' }]
      },
      saveLoading: false
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    async getDictData() {
      const data = await getDictData();
      this.treeData = data || [];
    },
    async getDict(id) {
      this.infoLoading = true;
      try {
        const data = await getDict(id);
        this.editForm = {
          id: data.id,
          parentId: data.parentId,
          parentName: data.parentName,
          name: data.name,
          code: data.code,
          value: data.value,
          valuex: data.valuex,
          valuey: data.valuey,
          address: data.address,
          remark: data.remark,
          levelCode: data.levelCode,
          deleted: data.deleted
        };
        this.fileList = (data?.img ? data.img.split(',') : []).map(item => ({
          name: item,
          url: item
        }));
      } finally {
        this.infoLoading = false;
      }
    },
    handleTreeNode(nodeData) {
      this.currentTreeNode = nodeData;
      const id = nodeData.id;
      this.currentNodeId = id;
      this.getDict(id);
    },
    resetTreeNode() {
      this.currentTreeNode = null;
      this.currentNodeId = null;
      this.handleReset();
      this.getDictData();
    },
    handleAddOrigin() {
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        const lastCode = this.treeData?.[this.treeData.length - 1]?.levelCode ?? null;
        let levelCode = getNextCode('', lastCode, 6);
        this.editForm = { ...this.editForm, levelCode };
        this.infoLoading = false;
      });
    },
    handleAddChildren() {
      const currentNode = this.currentTreeNode;
      if (!currentNode?.id) return this.$message.warning('请先选择要操作的上级字典！');
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        let lastCode = currentNode.nodes ? currentNode.nodes[currentNode.nodes.length - 1].levelCode : null;
        let levelCode = getNextCode(this.currentTreeNode.levelCode, lastCode, 6);
        this.editForm = { ...this.editForm, parentId: this.currentTreeNode.id, parentName: this.currentTreeNode.text, levelCode };
        this.infoLoading = false;
      });
    },
    handleReset() {
      this.$refs.editForm.resetFields();
      this.editForm = {
        deleted: 0,
        remark: '',
        name: ''
      };
      this.fileList = [];
    },
    handleSave() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.saveLoading = true;

          const img = this.fileList.map(item => item.url.replace(this.$imgUrl, '')).join(',');

          try {
            await saveDict({ ...this.editForm, img });
            this.$message.success('保存成功!');
            this.resetTreeNode();
          } finally {
            this.saveLoading = false;
          }
        }
      });
    },
    handleDelete() {
      const id = this.currentTreeNode?.id ?? null;
      if (!id) return this.$message.warning('请先选择要操作的字典！');
      if (this.currentTreeNode?.nodes?.length > 0) return this.$message.warning('该节点含有子字典，请先删除子字典！');

      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteDict(id);
          this.resetTreeNode();
          this.$message.success('删除成功');
        })
        .catch(() => {});
    },

    // 获取富文本编辑器内容
    getContent(content, dataType) {
      this.editForm[dataType] = content;
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.getDictData();
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  overflow: visible;
}
.el-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  &.cbox-p14 {
    padding-top: 0;
  }

  .search-box {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 14px;
    }
  }
  .button-box {
    margin: 10px 0;
  }
  .tree-box {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.el-main {
  margin-left: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .dashed-border {
    flex: 1 1 auto;
    min-height: 0;
    padding: 14px 14px 0 0;
    margin-bottom: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .form-buttons {
    text-align: right;
  }
  .el-empty {
    height: 100%;
  }
  &.cbox-p14 {
    padding-top: 0;
  }
}

.section-header {
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
</style>
